import { render } from "./SimpleDialog.vue?vue&type=template&id=5f6d1a2a"
import script from "./SimpleDialog.vue?vue&type=script&lang=js"
export * from "./SimpleDialog.vue?vue&type=script&lang=js"

import "./SimpleDialog.vue?vue&type=style&index=0&id=5f6d1a2a&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__